/**
 *
 * Config API URL, Google Maps Api Key, Google ReCaptcha SiteKey
 */

var app_env = process.env.MIX_APP_ENV;
var api_url = process.env.MIX_API_URL;
var cookie_consent_url = process.env.MIX_COOKIE_CONSENT_URL;
var google_maps_js_api = process.env.MIX_GOOGLE_MAPS_KEY;
var google_recaptcha_sitekey = process.env.MIX_GOOGLE_RECAPTCHA_SITEKEY;

export const ROAST_CONFIG = {
    APP_ENV: app_env,
    API_URL: api_url,
    COOKIE_CONSENT_URL: cookie_consent_url,
    GOOGLE_MAPS_JS_API: google_maps_js_api,
    GOOGLE_RECAPTCHA_SITEKEY: google_recaptcha_sitekey
}
